export default __webpack_public_path__ + "static/media/icon_china_no_data.6250fdc8.svg";